/* src/modules/auth/api.js */

import gql from 'graphql-tag';

export const VALIDATE_TOKEN_MUTATION = gql`
  mutation validateToken($token: String!) {
    validateToken(token: $token) {
      adminToken
    }
  }
`;

export const LOGIN_MUTATION = gql`
  mutation login($email: String!, $password: String!) {
    login(email: $email, password: $password, admin: true) {
      adminToken
    }
  }
`;

export const LOGIN_2FA_MUTATION = gql`
  mutation loginTwoFactor($email: String!, $password: String!) {
    login: loginTwoFactor(email: $email, password: $password) {
      twoFactorToken
    }
  }
`;

export const VERIFY_2FA_MUTATION = gql`
  mutation verifyTwoFactor($token: String!, $code: String!) {
    verifyTwoFactor(token: $token, code: $code) {
      adminToken
    }
  }
`;

export const PROFILE_FRAGMENT = gql`
  fragment ProfileFragment on Admin {
    _id
    type
    stripe {
      currency
      cards {
        id
        name
        last4
        expMonth
        expYear
        default
      }
    }
    organizations {
      _id
      credits
      creditsDistributed
      creditsUsed
      subsidies {
        _id
        creditsDistributed
        creditsUsed
        name
        description
        image
        autoApprove
        approvalCount
        requestedCount
      }
      name
      surveySkippable
      reviewMandatory
      currency
      cancelation {
        enabled
        time
        penalty
      }
      serviceFee {
        slope
        shift
      }
      commission {
        nodes
        slopes
      }
      payment {
        mode
        stripe_id
        split_charge
      }
      supportPhone
      supportChannels
      supportEmail
      tutorSupportEmail
    }
    universities {
      _id
      name
      ssoEmailDomain
      ssoEndpoint
    }
    interview_universities {
      _id
    }
    permissions
    notificationPreference {
      type
      email
      notification
    }
    user {
      _id
      first
      last
      avatar
      email
    }
  }
`;

export const FETCH_USER_QUERY = gql`
  {
    adminSelf {
      ...ProfileFragment
    }
  }
  ${PROFILE_FRAGMENT}
`;

export const FORGOT_PASSWORD_MUTATION = gql`
  mutation forgotPassword($email: String!) {
    forgotPassword(email: $email)
  }
`;



// WEBPACK FOOTER //
// ./src/modules/auth/api.js